import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { NotFoundIcon } from './styled';
import WrongPageLayout from './WrongPageLayout';

const NotFound = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'notFound' });
  const navigate = useNavigate();

  const onGoMainPage = useCallback(() => {
    navigate('/');
  }, []);

  return (
    <WrongPageLayout
      icon={<NotFoundIcon />}
      onClick={onGoMainPage}
      subtitle={t('subtitle')}
      title={t('title')}
    />
  );
};

export default NotFound;
